(() => {
  const STYLE_ID = 'clotaire-options-style';

  // Présentation Clotaire
  const css = `
    .clotaire-creoles .clotaire-step-heading {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 12px;
      color: #30251D;
      font-size: 17px;
      font-weight: 700;
      line-height: 1.4;
    }

    .clotaire-creoles .clotaire-step-number {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 30px;
      width: 30px;
      height: 30px;
      border-radius: 6px;
      background: #63452F;
      color: #FFFFFF;
      font-size: 15px;
      font-weight: 700;
    }

    .clotaire-creoles .clotaire-selected-box {
      display: flex;
      align-items: center;
      gap: 9px;
      padding: 12px;
      margin-bottom: 14px;
      border-radius: 7px;
      background: #F7F0E6;
      color: #63452F;
      font-size: 14px;
      line-height: 1.4;
    }

    .clotaire-creoles .clotaire-selected-check {
      font-size: 17px;
      color: #735338;
    }

    .clotaire-creoles .clotaire-selected-value {
      font-weight: 600;
    }

    .clotaire-creoles .clotaire-selected-caption {
      margin-left: auto;
      color: #8C745B;
      font-size: 12px;
    }

    /* Masquer le titre d'origine de l'application */
    .clotaire-creoles > .fcpo-option__legend {
      display: none !important;
    }

    /* Boutons non sélectionnés */
    .clotaire-creoles label.fcpo-button {
      appearance: none !important;
      background: #FFFFFF !important;
      background-color: #FFFFFF !important;
      border: 1px solid #D9C7AE !important;
      border-radius: 6px !important;
      color: #63452F !important;
      box-shadow: none !important;
      outline: none !important;
      filter: none !important;
    }

/* Bouton sélectionné */
.clotaire-creoles label.fcpo-button:has(input:checked) {
  background: #F7F0E6 !important;
  background-color: #F7F0E6 !important;
  border: 1px solid #735338 !important;
  border-radius: 6px !important;
  color: #63452F !important;
  box-shadow: none !important;
  outline: none !important;
  filter: none !important;
}

.clotaire-creoles label.fcpo-button:has(input:checked) .fcpo-button__text {
  background: transparent !important;
  color: #63452F !important;
}

/* Neutraliser les contours internes de l'application */
.clotaire-creoles label.fcpo-button::before,
.clotaire-creoles label.fcpo-button::after {
  content: none !important;
}

.clotaire-creoles label.fcpo-button .fcpo-button__text {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

    /* Neutraliser les effets internes */
    .clotaire-creoles label.fcpo-button .fcpo-button__text {
      background: transparent !important;
      color: #63452F !important;
      box-shadow: none !important;
      outline: none !important;
    }

    /* Conserver les prix secondaires discrets */
    .clotaire-creoles .fcpo-price-tag {
      background: transparent !important;
      color: #8C745B !important;
      box-shadow: none !important;
    }

/* Neutraliser les contours supplémentaires de l'application */
.clotaire-creoles .fcpo-buttons {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.clotaire-creoles label.fcpo-button,
.clotaire-creoles label.fcpo-button::before,
.clotaire-creoles label.fcpo-button::after,
.clotaire-creoles label.fcpo-button .fcpo-button__text {
  box-shadow: none !important;
  outline: none !important;
}

.clotaire-creoles label.fcpo-button::before,
.clotaire-creoles label.fcpo-button::after {
  border: none !important;
}

    /* Accessibilité clavier */
    .clotaire-creoles label.fcpo-button:has(input:focus-visible) {
      outline: 2px solid #735338 !important;
      outline-offset: 2px !important;
    }

    @media (max-width: 749px) {
      .clotaire-creoles .clotaire-step-heading {
        font-size: 16px;
      }

      .clotaire-creoles .clotaire-selected-box {
        padding: 10px;
      }
    }
  `;

  let style = document.getElementById(STYLE_ID);

  if (!style) {
    style = document.createElement('style');
    style.id = STYLE_ID;
    document.head.appendChild(style);
  }

  style.textContent = css;

  // Formater le texte du choix sans modifier le prix réel
  function formatChoice(label) {
    const name = label
      .querySelector('.fcpo-button__text')
      ?.childNodes;

    if (!name) return 'Aucune sélection';

    const title = Array.from(name)
      .filter(node => node.nodeType === Node.TEXT_NODE)
      .map(node => node.textContent.trim())
      .filter(Boolean)
      .join(' ');

    const price = label
      .querySelector('.fcpo-price-tag')
      ?.textContent
      ?.trim();

    if (!price) return title || 'Aucune sélection';

    // Exemples : +€5,00 ou +5,00 €
    const amount = price.match(/[\d]+(?:[.,][\d]+)?/);

    if (!amount) return title;

    return `${title} (+${amount[0]} €)`;
  }

  function getStepNumber(picker) {
    const personalized =
      picker.dataset.personalizedPicker === 'true';

    if (personalized) return 3;

    const options = picker.querySelectorAll(
      'fieldset.variant-option'
    );

    return options.length + 1;
  }

  function setup() {
    const picker = document.querySelector(
      'variant-picker[data-template-product-match="true"]'
    );

    if (!picker) return;

    const number = getStepNumber(picker);

    document
      .querySelectorAll('fieldset.fcpo-option')
      .forEach(fieldset => {
        const legend = fieldset.querySelector(
          '.fcpo-option__legend'
        );

        if (!legend) return;

        if (
          !legend.textContent
            .toLowerCase()
            .includes('créoles')
        ) return;

        if (
          fieldset.classList.contains('clotaire-creoles')
        ) return;

        fieldset.classList.add('clotaire-creoles');

        // Étape chocolat
        const heading = document.createElement('div');
        heading.className = 'clotaire-step-heading';

        const step = document.createElement('span');
        step.className = 'clotaire-step-number';
        step.textContent = String(number);

        const title = document.createElement('span');
        title.textContent = 'Sélectionnez vos créoles :';

        heading.append(step, title);

        // Encart champagne
        const box = document.createElement('div');
        box.className = 'clotaire-selected-box';

        const check = document.createElement('span');
        check.className = 'clotaire-selected-check';
        check.textContent = '✓';

        const value = document.createElement('span');
        value.className = 'clotaire-selected-value';

        const caption = document.createElement('span');
        caption.className = 'clotaire-selected-caption';
        caption.textContent = 'Sélectionné';

        box.append(check, value, caption);

        legend.insertAdjacentElement(
          'afterend',
          heading
        );

        heading.insertAdjacentElement(
          'afterend',
          box
        );

        // Synchronisation avec les boutons de l'application
        const update = () => {
          const selected = fieldset.querySelector(
            'input[type="radio"]:checked'
          );

          const label = selected?.closest(
            'label.fcpo-button'
          );

          if (!label) {
            value.textContent = 'Aucune sélection';
            return;
          }

          value.textContent = formatChoice(label);
        };

        fieldset.addEventListener('change', update);
        update();
      });
  }

  // Initialisation et prise en charge du chargement dynamique
  let scheduled = false;

  const observer = new MutationObserver(() => {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      setup();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setup();
})();
